import { debugAtom, debugStore } from "@folio-2026/experience"
import Camera from "@folio-2026/section/camera"
import { EVENTS } from "@folio-2026/shared"
import * as THREE from "three/webgpu"

export default class ContactSectionCamera extends Camera {
  private basePosition = { x: 0.5, y: 3, z: 2.5 }
  private baseLookAt = { x: 0.5, y: 3, z: 0 }

  private isOrbitControls: boolean = false

  constructor({ scene }: { scene: THREE.Scene }) {
    super({ scene })

    this.setDebug()
    this.eventListeners()
  }

  eventListeners() {
    this.experience.on(EVENTS.Contact.Entering, (params: unknown) => {
      const { progress } = params as { progress: number }
      const newZ = THREE.MathUtils.lerp(4.5, 2.5, progress)
      this.basePosition.z = newZ
      this.camera.position.z = newZ
    })
  }

  update() {
    super.update()

    if (this.isOrbitControls) {
      return
    }

    this.lerpPosition()
    this.calculateOffset()
    this.updateCameraPosition()
  }

  private updateCameraPosition() {
    // Apply mouse offset to camera position
    const positionX = this.basePosition.x + this.mouseOffset.x
    const positionY = this.basePosition.y + -this.mouseOffset.y
    const positionZ = this.basePosition.z + this.mouseOffset.x

    // Apply mouse offset to look at position for rotation effect
    const lookAtX = this.baseLookAt.x + this.mouseOffset.x * 1.5
    const lookAtY = this.baseLookAt.y + -this.mouseOffset.y * 1.5
    const lookAtZ = this.baseLookAt.z + this.mouseOffset.x

    this.camera.position.set(positionX, positionY, positionZ)
    this.camera.lookAt(lookAtX, lookAtY, lookAtZ)
  }

  setDebug() {
    debugStore.sub(debugAtom, () => {
      const state = debugStore.get(debugAtom)

      this.isOrbitControls = state.showOrbitControls
    })
  }
}
